import React from "react";

import { Box, Button, Divider, Grid, Paper, Stack, Typography } from "@mui/material";

import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PlaceIcon from '@mui/icons-material/Place';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import PaymentsIcon from '@mui/icons-material/Payments';

import Carousel from 'react-elastic-carousel'

import "../index.css"
import Map from "../../../components/Map/Map";

const ProjectPresentationPage = () => {
  return (
    <Stack direction={"column"}>
      <Grid sx={{ backgroundColor: "#002f4f", height: "60vh" }}></Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        sx={{
          height: "100vh",
          padding: "0 50px",
        }}
      >
        <Grid item xs={8}
          sx={{
            backgroundColor: "white",
            position: "relative",
            bottom: "15vh",
            height: "115vh",
            padding: "50px"
          }}
        >
          <Box>
            <Typography variant="h1" sx={{fontSize: "2.7rem", textTransform: "uppercase"}}>Titre du projet</Typography>
            <div style={{width: 70, height: 3, backgroundColor: "#46bda7"}}></div>
          </Box>
          <Box sx={{display: "flex", flexDirection: "row", marginTop: 3}}>
            <Button variant="outlined" color="grey" sx={{marginRight: 2}}>Biodiversité</Button>
            <Button variant="outlined" color="grey" sx={{marginRight: 2}}>Climat</Button>
          </Box>
          <Paper 
            sx={{
              backgroundImage: "url('https://bsmedia.business-standard.com/_media/bs/img/article/2020-11/06/full/1604628875-5146.jpg')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "422px",
              borderRadius: 0,
              marginTop: 5
            }}
            elevation={0}
          >
            <Grid container direction="column" sx={{height: "100%"}}>
              <Grid item xs={10}></Grid>
              <Grid item xs={2} sx={{position: "relative"}}>
                <Grid container sx={{ 
                  p: 2,
                  color: "white", 
                  zIndex: "999999", 
                  position: "absolute",
                  top: 0, bottom: 0, left: 0, right: 0,
                }}>
                  <Grid item xs={4}>
                    <Typography marginTop={2}>
                      Bambous, Mauritius
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Carousel itemsToShow={6} pagination={false} leftArrow={<ChevronLeftOutlinedIcon/>} rightArrow={<ChevronRightOutlinedIcon/>}>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                      <Paper 
                        sx={{
                          backgroundImage: "url('https://www.trinasolar.com/sites/default/files/2021081201.png')",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: "50px",
                          width: "50px",
                          borderRadius: 0
                        }}
                        elevation={0}
                      ></Paper>
                    </Carousel>
                  </Grid>
                </Grid>
                <Paper
                  sx={{
                    filter: "blur(3px)",
                    backgroundImage: "url('https://bsmedia.business-standard.com/_media/bs/img/article/2020-11/06/full/1604628875-5146.jpg')",
                    backgroundColor: "rgba(0,0,0,1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPositionY: "61%",
                    height: "100%",
                    position: "absolute",
                    top: 0, bottom: 0, left: 0, right: 0,
                    borderRadius: 0,
                    zIndex: "0"
                  }}
                ></Paper>
              </Grid>
            </Grid>
          </Paper>
          <Box sx={{marginTop: 5}}>
            <Typography sx={{fontSize: "20px", fontWeight: "bold"}}>
              Avec ce projet, l'AFD contribue à la préservation des écosystèmes forestiers naturels et à l'amélioration des conditions de vie des populations riveraines.
            </Typography>
          </Box>
          <Box sx={{marginTop: 5}}>
            <Typography sx={{fontSize: "32px", fontWeight: "bold"}} color="primary">
              CONTEXTE
            </Typography>
            <Typography sx={{fontSize: "16px", fontWeight: "lighter", marginTop: 3 }}>
              Madagascar est classé parmi les « hot spot » de la biodiversité mondiale. La variété des climats, conjuguée à celle des reliefs, a favorisé le développement d’une faune et d’une flore uniques au monde. La biodiversité de Madagascar est aujourd’hui largement menacée par les activités anthropiques, notamment la déforestation, et les ressources exceptionnelles de l’Ile attisent les convoitises (secteur minier, pierres et minerais précieux, bois précieux, etc.).
              <br/><br/>
              Les autorités malgaches ont ratifié les grandes conventions sur l’environnement et la biodiversité et ont développé une vision ambitieuse en matière de protection de l’environnement et de lutte contre le changement climatique : loi Gelose de 1996, les engagements à Durban, politique nationale de lutte contre le changement climatique élaborée en 2010. Seulement, depuis 2009 et les nombreux changements successifs à la tête du ministère ont retardé les actions concrètes sur le terrain.
            </Typography>
          </Box>
          <Box sx={{marginTop: 5}}>
            <Typography sx={{fontSize: "32px", fontWeight: "bold"}} color="primary">
              DESCRIPTIF
            </Typography>
            <Typography sx={{fontSize: "16px", fontWeight: "lighter", marginTop: 3 }}>
            Le Projet holistique de conservation des forêts (PHCF), dont la première phase a débuté en 2008, vise à endiguer la déforestation et à assurer l'avenir des populations locales. Cinq sites avaient été sélectionnés pour leur biodiversité et leur vulnérabilité à la déforestation. Après des résultats encourageants, une seconde phase a donc été lancée en 2013 pour une durée de 4 ans avec pour objectifs :
            <ul>
              <li>Réduire la pression sur les forêts : avec la mise en place d'activités de conservations.</li>
              <li>Promouvoir des alternatives durables à l’exploitation destructrice des ressources forestières et répondre aux besoins de la population.</li>
              <li>Pérenniser les activités entreprises grâce au financement carbone et participer à la stratégie nationale.</li>
            </ul>
            </Typography>
          </Box>
          <Box sx={{marginTop: 5}}>
            <Typography sx={{fontSize: "32px", fontWeight: "bold"}} color="primary">
              IMPACTS
            </Typography>
            <Typography sx={{fontSize: "16px", fontWeight: "lighter", marginTop: 3 }}>
            Des contrats de Transfert de gestion des ressources naturelles ont été mis en place ou renouvelés au niveau de 13 communautés. Dans la zone du COMATSA, le suivi écologique communautaire est opérationnel. En outre, 46 pépinières ont été installées avec une production d’environ 35 000 jeunes plants. Plus de 600 contrats de développement et de conservation explicitant les engagements réciproques entre le projet et le producteur, ont été conclus, et environ 500 producteurs sont en cours d’accompagnement par le projet. Au niveau de la composante « Finance Carbone », 4 articles scientifiques ont été rédigés et publiés dans différentes revues.
            </Typography>
          </Box>
          <Paper id="map" sx={{height: "calc(100vh - 300px)", marginTop: 5}} elevation={0}>
            <Typography sx={{fontSize: "32px", fontWeight: "bold", marginBottom: 3}} color="primary">
              LOCALISATION
            </Typography>
            <Map />
          </Paper>
          <Box sx={{marginTop: "100px", marginBottom: 10}}>
            <Typography sx={{fontSize: "32px", fontWeight: "bold"}} color="primary">
              PARTENAIRES
            </Typography>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={4}>
                <Paper
                  sx={{
                    backgroundImage: "url('https://www.inter-reseaux.org/wp-content/uploads/arton14044-1024x512.png')",
                    backgroundSize: "cover",
                    height: "100px",
                  }}
                  elevation={0}
                ></Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper
                  sx={{
                    backgroundImage: "url('data:image/png;base64,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')",
                    backgroundSize: "cover",
                    height: "100px",
                  }}
                  elevation={0}
                ></Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper
                  sx={{
                    backgroundImage: "url('https://www.gavi.org/sites/default/files/2019-11/unicef.png')",
                    backgroundSize: "cover",
                    height: "100px",
                  }}
                  elevation={0}
                ></Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper
                  sx={{
                    backgroundImage: "url('data:image/png;base64,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')",
                    backgroundSize: "cover",
                    height: "100px",
                  }}
                  elevation={0}
                ></Paper>
              </Grid>
            </Grid>
          </Box>
          <Box></Box>
        </Grid>
        <Grid item xs={4}
          sx={{
            backgroundColor: "white",
            position: "relative",
            bottom: "15vh",
            height: "115vh",
            padding: "50px"
          }}
        >
          <Grid>
            <Grid>
              <Box>
                <Typography variant="h1" sx={{fontSize: "2.7rem", textTransform: "uppercase"}} color="secondary">
                  <span>14/05/</span>
                  <span style={{color: '#46bda7'}}>2022</span>
                </Typography>
              </Box>
              <Paper elevation={0} sx={{marginTop: 5}}>
                <Grid container gap={2}>
                  <Grid item xs={1}>
                    <div className="project-duration">
                      <AccessTimeFilledIcon sx={{fontSize: "30px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "20px", color: "#747474"}}>
                        <span  style={{color: '#002f4f', paddingRight: "10px"}}>4 ans</span>
                        <span>Durée du projet</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>

              <Divider sx={{marginTop: 5, marginBottom: 5}} />
              
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={2}>
                    <div className="project-infos">
                      <LocalFloristIcon sx={{fontSize: "60px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>22 000 t CO2</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Volume annuel de décarbonation</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Paper elevation={0} sx={{marginTop: 5}}>
                <Grid container spacing={7}>
                  <Grid item xs={2}>
                    <div className="project-infos">
                      <WarehouseIcon sx={{fontSize: "60px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>22 000 CarbonCumac</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Volume de décarbonation sur la duree de vie du projet</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Divider sx={{marginTop: 5, marginBottom: 5}} />
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={2}>
                    <div className="project-infos">
                      <PaymentsIcon sx={{fontSize: "60px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>2 000 000EUR</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Montant du projet à financer</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={2}>
                    <div className="project-infos">
                      <MonetizationOnIcon sx={{fontSize: "60px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>2 000 000EUR</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Montant total du projet</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Divider sx={{marginTop: 5, marginBottom: 5}} />
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>En cours</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Etat</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>Itokiana Rajoelison</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Bénéficiaire(s)</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Divider sx={{marginTop: 5, marginBottom: 5}} />
              <Paper elevation={0} sx={{marginTop: 5, backgroundColor: "transparent"}}>
                <Grid container spacing={7}>
                  <Grid item xs={2}>
                    <div className="project-infos">
                      <PlaceIcon sx={{fontSize: "60px"}} color="secondary" />
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                      <Typography sx={{fontSize: "24px", color: "#002f4f"}}>
                        <span  style={{color: '#002f4f'}}>Bambous, Mauritius</span>
                      </Typography>
                      <Typography sx={{fontSize: "16px", color: "#747474", fontWeight: "lighter"}}>
                        <span>Localisation</span>
                      </Typography>
                  </Grid>
                </Grid>
              </Paper>
              <Divider sx={{marginTop: 5, marginBottom: 5}} />
              <Box sx={{ marginTop: 2, display: "flex", flexDirection: "row", alignItems: "center"}}>
                <Paper 
                  sx={{
                    width: "70px", 
                    height: "70px",
                    backgroundImage: "url('https://tourism4sdgs.org/wp-content/uploads/2018/09/E_SDG-goals_icons-individual-rgb-07-500x500.jpg')",
                    backgroundSize: "cover",
                    borderRadius: "0"
                  }}
                  elevation={0}
                ></Paper>
                <Typography sx={{marginLeft: 2, fontSize: "16px"}} color="secondary">Affordable and Clean Energy</Typography>
              </Box>
              <Box sx={{ marginTop: 2, display: "flex", flexDirection: "row", alignItems: "center"}}>
                <Paper 
                  sx={{
                    width: "70px", 
                    height: "70px",
                    backgroundImage: "url('https://dominicanrepublic.iom.int/sites/g/files/tmzbdl911/files/sdgs-icon/e_web_08.png')",
                    backgroundSize: "cover",
                    borderRadius: "0"
                  }}
                  elevation={0}
                ></Paper>
                <Typography sx={{marginLeft: 2, fontSize: "16px"}} color="secondary">Decent Work and Economic Growth</Typography>
              </Box>
              <Box sx={{ marginTop: 2, display: "flex", flexDirection: "row", alignItems: "center"}}>
                <Paper 
                  sx={{
                    width: "70px", 
                    height: "70px",
                    backgroundImage: "url('https://sustainabledevelopment.un.org/content/sdgsummit/images/E_SDG%20goals_icons-individual-rgb-09.png')",
                    backgroundSize: "cover",
                    borderRadius: "0"
                  }}
                  elevation={0}
                ></Paper>
                <Typography sx={{marginLeft: 2, fontSize: "16px"}} color="secondary">Industry, Innovation and Infrastructure</Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={{marginTop: "250vh"}}>
        <Paper color="secondary" sx={{height: "25vh", width:"100%"}}></Paper>
      </Grid>
    </Stack>
  );
};

export default ProjectPresentationPage;
